<template>
  <p v-if="isPrint" class="print-input">{{ dateRang.sDate }} ~ {{ dateRang.eDate }}</p>
  <div v-else class="time">
    <date-selector v-model="dateRang.sDate" :readonly="readonly" :max-date="dateRang.eDate" :class="readonly && 'date-readonly'" />
    <p>~</p>
    <date-selector v-model="dateRang.eDate" :readonly="readonly" :min-date="dateRang.sDate" :class="readonly && 'date-readonly'" />
  </div>
</template>

<script>
import DateSelector from "@/components/selector/DateSelector";

export default {
  components: {
    DateSelector,
  },
  props: {
    isPrint: Boolean,
    readonly: Boolean,
    value: { type: Object, default: () => ({ sDate: "", eDate: "" }) },
  },
  data() {
    return {
      dateRang: this.value,
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        this.dateRang = value;
      },
    },
    dateRang: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
        this.$emit("sDate", value.sDate);
        this.$emit("eDate", value.eDate);
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.date-readonly::v-deep {
  .vsinput input {
    background: #fafafa;
  }
}
</style>
